import React from 'react';
import { Skeleton, Grid } from '@mui/material';

const CrmSkeletonSpinner = () => {
  return (
    <div style={{ marginBottom: "8px" }}>
      {/* First Row */}
      <Grid container spacing={2} className="gridContainer" style={{ marginBottom: "8px" }}>
        <Grid item xs={6} md={2}>
          <Skeleton variant="rectangular" width="100%" height={40} />
        </Grid>
        <Grid item xs={6} md={2}>
          <Skeleton variant="rectangular" width="100%" height={40} />
        </Grid>
        <Grid item xs={5} md={2}>
          <Skeleton variant="rectangular" width="100%" height={40} />
        </Grid>
        <Grid item xs={5} md={2}>
          <Skeleton variant="rectangular" width="100%" height={40} />
        </Grid>
      </Grid>
      &nbsp; 
      {/* Second Row */}
      <Grid container spacing={2} className="gridContainer">
      <Grid item xs={6} md={2}>
          <Skeleton variant="rectangular" width="100%" height={40} />
        </Grid>
        <Grid item xs={6} md={2}>
          <Skeleton variant="rectangular" width="100%" height={40} />
        </Grid>
        <Grid item xs={5} md={2}>
          <Skeleton variant="rectangular" width="100%" height={40} />
        </Grid>
      </Grid>
    </div>
  );
};

export default CrmSkeletonSpinner;